<template>
  <div class="loading-logo" :class="{'animate-logo':animateLogo }">
    <div class="logo" ref="logoAnimation" @click="resetState"></div>
  </div>
</template>

<script>

  import lottie from 'lottie-web';

  export default {
    name: "LoadingLogo",

    data() {
      return {
        animation: null,
        animateLogo: false
      }
    },

    methods: {
      startAnimation() {
        this.animateLogo = true;
        this.animation.play();
        this.animation.setDirection(1);
      },
      revertLogo() {
        this.animateLogo = false;
        this.animation.setDirection(-1);
        this.animation.play();
      },
      resetState(){
        this.$emit('resetState')
      }
    },

    mounted() {
      this.animation = lottie.loadAnimation({
        container: this.$refs.logoAnimation,
        animationData: require('../animations/vitech_animation.json'),
        loop: false,
        autoplay: false,
        renderer: 'svg',
      });
    },

    beforeDestroy() {
      this.animation.destroy()
    }
  }
</script>

<style lang="scss">
  @import "LoadingLogo";
</style>
